import { adUnits } from './components/adSpotGrops/config';

let bannersCounter = 0;
export const convertToAdUnits = (
    acc,
    {
        ak, url, value, width, height, container, isPortrait, isBarsHidden, autoClose, shouldBeHovered, vcr, wfn, type, bannerType,
    }
) => {
    let name = '';
    if (type === 'VAST') {
        const checkOrientation = isPortrait ? 'inFeedPortrait' : 'inFeedLandscape';
        name = container === 'vast_safe' ? 'safeInFeedLandscape' : checkOrientation;

        ak = new URL(url).searchParams.get('appId');
        if (ak === null) {
            if (Object.keys(acc).includes('vastUrls')) {
                acc.vastUrls.push({ url, isPortrait });
                return acc;
            }
            return { ...acc, vastUrls: [{ url, isPortrait }] };
        }
    }
    if (type === 'passback') {
        const text = value.map((char) => String.fromCharCode(char)).reduce((acc, char) => acc + char, '');
        name = 'passback';

        return { ...acc, [name]: { value: text, width, height } };
    }

    const containerMap = {
        fullscreen: 'richMediaPortrait',
        expandable_banner: 'expandableBanner',
        scroller_safe: 'htmlRichMedia',
        scroller: 'fullscreenPortraitScroller',
        inview: 'inView',
    };
    if (Object.keys(containerMap).includes(container)) {
        name = containerMap[container];
    }
    if (container === 'webinfeed_static') {
        const index = bannerType || bannerType === 0 ? bannerType : bannersCounter;
        name = ['phoneBanner', 'mpu', 'leaderboard', 'halfpage', 'skyscraper'][index];
        bannersCounter = bannersCounter + 1;
    }
    return {
        ...acc,
        [name]: {
            ak,
            autoClose: autoClose || adUnits[name].autoClose,
            container: container || adUnits[name].container,
            isBarsHidden: isBarsHidden || adUnits[name].isBarsHidden,
            isPortrait: isPortrait || adUnits[name].isPortrait,
            shouldBeHovered: shouldBeHovered || adUnits[name].shouldBeHovered,
            vcr: vcr || adUnits[name].vcr,
            type: type || adUnits[name].type,
            wfn,
        },
    };
};
export const updateAk = (adUnits, name, ak) => {
    return {
        ...adUnits,
        [name]: {
            ...adUnits[name],
            hasError: !ak.match(/^[a-z0-9]{1,10}$/),
            ak,
        },
    };
};
export const toggleAdUnitCheckbox = (adUnits, name, field) => {
    return {
        ...adUnits,
        [name]: {
            ...adUnits[name],
            [field]: !adUnits[name][field],
        },
    };
};
export const updateSelectedField = (adUnits, name) => {
    const unselectedField = name === 'safeInFeedLandscape' ? 'htmlRichMedia' : 'safeInFeedLandscape';
    const selected = adUnits[name].selected === true ? false : true;

    return {
        ...adUnits,
        [name]: {
            ...adUnits[name],
            selected,
        },
        [unselectedField]: {
            ...adUnits[unselectedField],
            selected: false,
        },
    };
};
export const updatePassbackSize = (adUnits, dimension, value) => {
    const toNumber = (value, prevValue) => {
        const fourDigits = /\d{0,4}/i;
        if (value.match(fourDigits)) {
            return value.match(fourDigits)[0];
        }
        return prevValue;
    };
    return {
        ...adUnits,
        passback: {
            ...adUnits['passback'],
            [dimension]: toNumber(value, adUnits['passback'][dimension]),
        },
    };
};
